export default __webpack_public_path__ + "static/media/warrior-logo.367df232.svg";